<template>
  <div
    class="c-nav-content"
    :class="layoutClasses"
  >
    <nav-column
      class="c-nav-content__primaryNav"
      :class="{
        'c-nav-content__primaryNav--mobile': isMobile
      }"
      :heading="primaryNavTitle"
      :nav-items="primaryNav"
    />
    <div
      v-if="secondaryNav"
      class="c-nav-content__secondaryNav"
      :class="secondaryNavClasses"
    >
      <template v-for="item in secondaryNav">
        <component
          :is="item.contentType"
          :key="item._uid"
          v-bind="item.data ? item.data : item"
          :is-mobile="isMobile"
        />
      </template>
    </div>
  </div>
</template>

<script>
import NavColumn from './NavColumn'
import NavCombinationLayout from './NavCombinationLayout'
import NavFourColumnGrid from './NavFourColumnGrid'
import NavSingleRow from './NavSingleRow'
import NavItem from './sharedComponents/NavCard.vue'
import get from 'lodash/get'
export default {
  components: {
    NavColumn,
    NavCombinationLayout,
    NavFourColumnGrid,
    NavSingleRow,
    NavItem,
  },
  props: {
    navItem: {
      type: Object,
      required: true
    },
    isMobile: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    layoutClasses() {
      const isMobile = this.isMobile
      let result = [
        'u-background-color-base',
        'j-nav-item__scroll',
      ]
      if (isMobile) {
        result.push(
          'l-flex',
          'l-flex--column',
        )
      } else {
        result.push(
          'l-grid',
          'l-grid--2-col-second-long'
        )
      }
      return result
    },
    primaryNavTitle() {
      return get(this.navItem, 'data.primaryNavTitle')
    },
    primaryNav() {
      return get(this.navItem, 'data.primaryNav')
    },
    secondaryNav() {
      const navItems = get(this.navItem, 'data.secondaryNav')
      return (navItems.length >= 12) ? navItems.slice(0, 12) : navItems
    },
    secondaryNavClasses() {
      const isMobile = this.isMobile
      const secondaryNav = this.secondaryNav
      let result = []
      if (isMobile) {
        result.push('l-grid')
        if (secondaryNav.length > 1) {
          result.push(
            'l-grid--2-col'
          )
        }
      } else if (secondaryNav) {
        if ((secondaryNav.length % 3) === 0) {
          result.push('l-grid', 'l-grid--3-col')
        } else if (secondaryNav.length > 1) {
          result.push('l-grid', 'l-grid--4-col')
        }
      }
      return result
    }
  }
}
</script>

<style lang="scss" scoped>
.c-nav-content {
  margin: 0 rem(20px);
  grid-template-columns: 1.05fr 4fr;
  grid-gap: 1rem;
  align-items: start;
  @include respond('large-desktop') {
    margin: 0 rem(100px);
  }
  @include respond('tab-port') {
    margin: 0 rem(50px) rem(20px);
  }
  &__primaryNav {
    &--mobile {
      @include respond-min('tab-land') {
        width: 100%;
        max-width: unset;
        flex-wrap: wrap;
        max-height: rem(200px);
      }
    }
    @include respond('tab-port') {
      max-width: unset;
      width: 100%;
    }
  }
  &__secondaryNav {
    padding-bottom: rem(10px);
    align-items: start;
    grid-gap: 1rem;
    @media only screen and (min-width: 1200px) and (max-width: 1300px) {
      grid-gap: 0.75rem;
    }
    @include respond('tab-land') {
      width: 100%;
    }
  }
  .c-nav-column::v-deep {
    @include respond('tab-port') {
      padding: 2rem;
      width: 100%;
    }
  }
  .c-nav-card::v-deep {
    height: 100%;
    .c-nav-card__header {
      font-size: large;
      margin-bottom: rem(5px);
    }
    @media only screen and (min-width: 1200px) and (max-width: 1300px) {
      .c-nav-card__header {
        font-size: small;
      }
    }
    @include respond('tab-port') {
      width: 100%;
    }
  }
}
</style>
